import actions from "./actions.js";
import mutations from "./mutations.js";

const initialState = () => {
  return {
    showIndeterminateLoading: false,
    descriptionText: "Loading"
  };
};

export const progressComponentModule = {
  state: initialState(),
  namespaced: true,
  getters: {},
  actions,
  mutations
};
